module.exports = __webpack_public_path__ + "static/1_1_defineai_SE-77dd5b1aadf4bab857f241f55a6dcebd.svg";